import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

if (typeof window !== 'undefined') {
  window.prerenderReady = false;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages sans SEO async (routes privées, etc.)
setTimeout(() => {
  if (typeof window !== 'undefined' && window.prerenderReady === false) {
    window.prerenderReady = true;
  }
}, 8000);

